import smallFitnessScreen from 'images/landing/global/features/screens/fitness/small.png'
import mediumFitnessScreen from 'images/landing/global/features/screens/fitness/medium.png'
import largeFitnessScreen from 'images/landing/global/features/screens/fitness/large.png'

import smallRideScreen from 'images/landing/global/features/screens/ride/small.png'
import mediumRideScreen from 'images/landing/global/features/screens/ride/medium.png'
import largeRideScreen from 'images/landing/global/features/screens/ride/large.png'

import smallRunScreen from 'images/landing/global/features/screens/run/small.png'
import mediumRunScreen from 'images/landing/global/features/screens/run/medium.png'
import largeRunScreen from 'images/landing/global/features/screens/run/large.png'

import smallWalkScreen from 'images/landing/global/features/screens/walk/small.png'
import mediumWalkScreen from 'images/landing/global/features/screens/walk/medium.png'
import largeWalkScreen from 'images/landing/global/features/screens/walk/large.png'

import smallHikeScreen from 'images/landing/global/features/screens/hike/small.png'
import mediumHikeScreen from 'images/landing/global/features/screens/hike/medium.png'
import largeHikeScreen from 'images/landing/global/features/screens/hike/large.png'

const flavorScreens = {
  fitness: {
    src: smallFitnessScreen,
    medium: mediumFitnessScreen,
    xlarge: largeFitnessScreen,
  },
  ride: {
    src: smallRideScreen,
    medium: mediumRideScreen,
    xlarge: largeRideScreen,
  },
  run: {
    src: smallRunScreen,
    medium: mediumRunScreen,
    xlarge: largeRunScreen,
  },
  walk: {
    src: smallWalkScreen,
    medium: mediumWalkScreen,
    xlarge: largeWalkScreen,
  },
  hike: {
    src: smallHikeScreen,
    medium: mediumHikeScreen,
    xlarge: largeHikeScreen,
  },
}
export default flavorScreens
